<template>
	<popup class="select-integration-popup"
	       :title="`${isEdit?'Edit':'Create a new'} automation`" relative @close="closePopup">
		<template v-slot:content>
			<div class="__content">

				<steps-header :steps="steps" />

				<div class="__integrations-wrap">
					<input type="text" placeholder="Type to search..." v-model="search" class="main-search-input">

					<Loading v-if="loading"/>
					<div v-else class="__integration-items">
						<IntegrationItem
								v-for="(item, index) in filteredList"
								:class="{active: userIntegration(item).active}"
								@click="selectItem(item)"
								@config="$emit('config',item)"
								:key="item.id"
								:item="item"/>
					</div>
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button v-if="!isEdit" label="Back" slim border @click="$emit('back')" />
			<v-button label="Continue" disabled slim @click="$emit('done',automation)" />
			<v-button label="Cancel" slim border @click="closePopup" />
		</template>
	</popup>
</template>

<script>

import API from "@/api"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import Step1 from "@/components/popups/automation/Step1";
import StepsHeader from "@/components/popups/automation/steps/steps-header";
import Step2 from "@/components/popups/automation/Step2";
import IntegrationItem from "@/components/automation-parts/IntegrationItem";

export default {
  name: "select-integration-popup",
	mixins: [API],
	props:{
		automation:{type:Object},
		currentProduct:{type:Object},
		edit:{type:Object},
		productId:{},
		stepId:{},
		funnelId:{},
		isEdit:{type:Boolean},
	},
  components: {
	  IntegrationItem,
	  Step2,
	  StepsHeader,
	  Step1,
    Popup,
      Loading,
      VButton
  },
  data() {
    return {
	    loading: false,
	    step: 1,
	    triggerId:0,
	    integrations:[],
	    search:'',
    }
  },
  computed: {
		triggerTag() {
			if (!this.automation.trigger_id) return "";
			return ['Purchase','Refund','New subscription',
			        'Subscription canceled','Recurring payment','Recurring payment fails'][this.automation.trigger_id-1]
		},
		steps(){
			return [
				{
					id: 1, name: "Select a trigger",
					tag: this.triggerTag,
					step: "Step1", status: "completed"
				},
				{
					id: 2, name: "Select an integration", tag: "", step: "Step2", status: "active"
				},
				{
					id: 3, name: "What action to trigger?", tag: "", step: "Step3", status: "deactivated"
				}]
		},
	  filteredList() {
		  if(this.integrations) {
			  return this.integrations.filter(item => {
				  return item.caption.toLowerCase().includes(this.search.toLowerCase())
			  })
		  }
			return []
	  },
  },
  methods: {
	  selectItem(i) {
		  if(i.user_integration.active) {
				this.automation.integration_id = i.id;
			  this.$emit('done', this.automation);
		  }
	  },
	  userIntegration(i){
			return i.user_integration || {}
	  },
    closePopup() {
	    this.$emit('close');
    },
    firstDone(trigger, change = false) {
	    this.newData.trigger_id = parseInt(trigger);
	    var label = 'On Purchase';
	    switch (trigger) {
		    case 1:
			    label = 'On Purchase';
			    break;
		    case 2:
			    label = 'On Refund';
			    break;
		    case 3:
			    label = 'New Subscription';
			    break;
		    case 4:
			    label = 'Subscription Cancelled';
			    break;
	    }
	    this.steps[0].label = label;
    },
	  async load() {
		  try {
			  this.loading = true;
			  this.integrations = []
			  this.integrations = await this.api.steps.getIntegrations() || [];
		  } catch (e) {
			  this.$error(e);
		  } finally {
			  this.loading = false;
		  }
	  },
  },
	created() {
		this.load();
	}
}
</script>
<style lang="scss">
.select-integration-popup {
	.popup {
		max-width: 800px;
	}
}
</style>
<style lang="scss" scoped>
.select-integration-popup {
	.__content {
		display: flex;
		flex-direction: column;
	}
	.__integrations-wrap {
		display: flex;
		flex-direction: column;
		position: relative;
		min-height: 110px;
	}
	.__integration-items {
		margin-top: 15px;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 5px;
		gap: 15px;
	}
    .bottom-btns {
        display: flex;
        justify-content: flex-end;
        padding: 15px 20px;
        border-top: 1px solid rgba(206, 207, 216, 0.32);
    }

    .body {
      height: 100%;
      display: block;
      min-height: 9px;
      position: relative;
      padding: 10px 20px;
      overflow-y: auto;
      overflow-x: hidden;
      // max-width: 740px;
    }
    .bottom-btns .button {
        margin-left: 30px;
    }

}
</style>

